// extracted by mini-css-extract-plugin
module.exports = {"button":"button--tUiAOqmC1bYVl5Z9fvmW"};